// Reports API, through the shared client so the user's token is attached
// (bare fetch() 401'd for Bearer and break-glass users).
import { apiV1 } from './client';

const data = async (promise) => (await promise).data;

export const reportsApi = {
  generate: (name, type, format = 'json', filters = {}) =>
    data(apiV1.post('/reports/generate', { name, type, format, filters })),
  list: (params = {}) => data(apiV1.get('/reports/', { params })),
  // Counts over every report the caller may see (not the 50 on screen).
  stats: () => data(apiV1.get('/reports/stats')),
  get: (id) => data(apiV1.get(`/reports/${id}`)),
  delete: (id) => data(apiV1.delete(`/reports/${id}`)),
  // Fetched through the client (authenticated), then saved as a file.
  async download(id, filename) {
    const response = await apiV1.get(`/reports/download/${id}`, { responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || `report-${id}`;
    a.click();
    URL.revokeObjectURL(url);
  },
  // Body uses the model's names: type, frequency, email_recipients.
  createScheduled: (body) => data(apiV1.post('/reports/scheduled', body)),
  listScheduled: (params = {}) => data(apiV1.get('/reports/scheduled/list', { params })),
  runScheduledNow: (id) => data(apiV1.post(`/reports/scheduled/${id}/run`)),
  getTypeOptions: () => data(apiV1.get('/reports/options/types')),
  getFormatOptions: () => data(apiV1.get('/reports/options/formats')),
};

export default reportsApi;
